module.exports = __webpack_public_path__ + "img/11.2682db3c.png";